import { connect } from 'react-redux';

import { Filters, IFiltersProps } from '../../components/Filters';
import { IApplicationState, TThunkDispatch } from '../../types/redux';
import { EDealType } from '../../repositories/favorites/entities/favorite_entity_for_desktop/FavoriteEntityForDesktopSchema';
import { setDealType, setFavoriteEntityType } from '../../actions/filters';
import { fetchFavoriteEntities } from '../../actions/favoriteEntities';
import { unselectAll } from '../../actions/selected';
import { EEntityType } from '../../types/filters';

type TFiltersStateProps = Pick<IFiltersProps, 'filters' | 'results' | 'counts'>;
type TFiltersDispatchProps = Pick<IFiltersProps, 'setDealType' | 'setFavoriteEntityType' | 'getFavoriteEntities'>;

function mapStateToProps(state: IApplicationState): TFiltersStateProps {
  return {
    filters: state.filters,
    results: state.results,
    counts: state.counts,
  };
}

function mapDispatchToProps(dispatch: TThunkDispatch): TFiltersDispatchProps {
  return {
    setDealType: (dealType: EDealType | null) => dispatch(setDealType(dealType)),
    setFavoriteEntityType: (favoriteEntityType: EEntityType | null) => {
      dispatch(unselectAll());

      return dispatch(setFavoriteEntityType(favoriteEntityType));
    },
    getFavoriteEntities: () => {
      return dispatch(fetchFavoriteEntities({ offset: 0 }));
    },
  };
}

export const FiltersContainer = connect(mapStateToProps, mapDispatchToProps)(Filters);
